import { proxy } from 'valtio'
import { useQuery } from 'react-query'
import { CommonApi, ApplicationCertificateType } from '../../generated'
import { apiConfig } from '../apiConfig'
import { CertificateType } from '../applications/CertificateType'

export const applicationCertificateTypeProgramTypeStore = proxy<{
  items: ApplicationCertificateType[]
}>({
  items: [],
})

const api = new CommonApi(apiConfig)

export async function loadApplicationCertificateType() {
  await api.getApplicationCertificateTypes().then((result) => {
    applicationCertificateTypeProgramTypeStore.items = result
  })
}

export function getApplicationCertificateTypesByCertificateType(certType: CertificateType): ApplicationCertificateType[] {
  if (certType.courseId === undefined) return []
  const list = applicationCertificateTypeProgramTypeStore.items
  const result = list.filter((item) => {
    return item.courseId === certType.courseId &&
      item.studentType === certType.studentType
  })
  return result
}

